import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { formatPrice } from "../../Functions/Price";
import { GetDataPromise } from "../../Functions/SendingData";
import { Loading } from "../../Loading";
import ReactHtmlParser from 'react-html-parser';
import draftToHtml from 'draftjs-to-html';


const CartStyle = styled.div`

    --n-primary-2: #0E3D5C;
    --n-grey-2: #E5E5E5;
    --n-grey-3: #CBCBCB;
    --n-grey-7: #979797;
    --n-grey-9: #5E5E5E;

    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: var(--body-2);
    box-shadow: 0px 4px 30px -4px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    flex-grow: 1;
    text-decoration: none;
    color: inherit;
    height: 100%;
    .good-image{
        display: block;
        position: relative;
        width: calc(100% - 22.54%);
        padding: 10% 11.27% ;
    }
    .good-desc{
        padding: 0.5rem 4.36%;
        text-align: right;
        font-size: 1rem;
        min-height: 5rem;
        display: flex;
        flex-direction: column;
        .title{
            font-size:1rem ;
            font-weight: 700;
        }
        .desc{
            flex-wrap: wrap;
            text-overflow: ellipsis;
            text-align: right;
            margin: auto;
            font-weight: 300;
            font-size: 0.8rem;
        }
    }
    .good-price{
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: baseline;
        text-align: left;
        font-weight: 400;
        font-size: 1.5rem;
        padding: 6% 4.36%;
        gap: 0.3rem;
        .price {
            font-size: 1.1rem;
        }

    }
    .line{
        border-bottom: 1px solid var(--n-grey-2);
        width: 100%;
    }
    .good-more{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 4% 5.82%;
        width: calc(100% - 11.64%);
        .date{
            font-weight: 700;
            font-size: 0.8rem;
        }
        .view{
            color: #1677D9;
            font-weight: 500;
            font-size: 0.8rem;
            text-decoration: none;
            cursor: pointer;
        }
    }
`



const GoodPostCart =(props)=>{
    const [alldata ,setAllData] = useState(false)
    useEffect(()=>{
        getData()
    },[])
    const getData = async ()=>{
        const value = props.data
        const data= {
            title: value.title.rendered,
            src:  <Loading/> ,
            short_desc: '',
            link: value.link,
            time:''
        }
        
        let split = value.content.rendered.split(' ')
        let count = Math.round(split.length / 200)
        if(count < 1){
            count = 1
        }
        data.time = count + ' دقیقه'

        let desc = ReactHtmlParser(draftToHtml(value))
        //  value.excerpt.rendered.replaceAll( /(<([^>]+)>)/ig, '');
        desc =  desc.replaceAll('&#8230;', '');
        data.short_desc = desc

        let img = await getTagData()
        data.src= <img className="good-image" src={img.source_url} alt={img.title.rendered}/>
        setAllData(data)
    }

    const getTagData = async () => {
        let data = await GetDataPromise(props.data._links['wp:featuredmedia'][0].href)
        let response = await JSON.parse(data)
        return(response)
    }

    if( alldata ){
        return (
            <CartStyle >
                {alldata.src}
                <div className="good-desc ">
                    <span className="title">{alldata.title}</span>
                    <span className="desc">
                    {alldata.short_desc.slice(0, 150)}...
                    </span>
                </div>
                <span className="line"></span>
                <div className="good-more">
                    <span className="date">{alldata.time}</span>
                    <a href={alldata.link+'/'} className="view" >مشاهده بیشتر</a>
                </div>
            </CartStyle>
        )
    }
    return  <Loading/> 

}
export default GoodPostCart;